import SelectHomeType from './SelectHomeType';

export default SelectHomeType;